module.exports = {"title":"Delete ticket","description":"Are you sure you want to delete that ticket?","yes":"Yes","no":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AlertModal/locales/fr.json
// module id = 1058
// module chunks = 0